import { ClarityUnmaskDirective } from 'app/shared/directives/clarity-unmask.directive';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '@service-features/auth.service';
import { NotificationService } from '@shared-services/handlers/notification.service';
import { firstValueFrom } from 'rxjs';
import { InlineSpinnerComponent } from '@shared-components/inline-spinner/inline-spinner.component';

@Component({
  selector: 'gd-registration-pending',
  standalone: true,
  imports: [
    InlineSpinnerComponent,
    ClarityUnmaskDirective,
    CommonModule,
    RouterLink,
  ],
  templateUrl: './registration-pending.component.html',
  styleUrl: './registration-pending.component.scss',
})
export class RegistrationPendingComponent {
  email = '';
  deliveryFailed = false;
  sending = false;
  constructor(
    private router: Router,
    private auth: AuthService,
    private notifications: NotificationService,
  ) {
    const state = this.router.getCurrentNavigation()?.extras.state;
    this.email = typeof state?.['email'] === 'string' ? state['email'] : '';
    this.deliveryFailed = state?.['emailDeliveryStatus'] === 'failed';
    //if (!this.email) void this.router.navigate(['/login']);
  }
  async resend(): Promise<void> {
    this.sending = true;
    try {
      const response = await firstValueFrom(
        this.auth.resendEmailConfirmation(this.email),
      );
      this.notifications.showTotast(response.payload);
    } catch (error: unknown) {
      this.notifications.showToastError(
        error,
        'No se pudo reenviar el email de confirmación.',
      );
    } finally {
      this.sending = false;
    }
  }
}
